<template>
    <v-container>
        <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <v-row dense>
            <v-col cols=3>
                <v-card class="py-3 px-5">
                    <v-card-text>
                        <v-row align="center">
                            <v-btn icon class="DC-AC-icon">
                                <span class="mdi mdi-contrast"></span>
                            </v-btn>
                            <div class="ms-4" style="color:#000;">
                                DC<br><b>{{ numberWithCommas(num_DC) }} MWp</b>
                            </div>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols=3>
                <v-card class="py-3 px-5">
                    <v-card-text>
                        <v-row align="center">
                            <v-btn icon class="DC-AC-icon">
                                <span class="mdi mdi-pulse"></span>
                            </v-btn>
                            <div class="ms-4" style="color:#000;">
                                AC<br><b>{{ numberWithCommas(num_AC) }} MWp</b>
                            </div>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-card class="mt-3 donut">
            <v-toolbar flat>
                <v-toolbar-title>
                    <b>異常詳細</b>
                </v-toolbar-title>
            </v-toolbar>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="filter d-flex">
                <div id="graph" class="mr-4">
                    <v-select
                        outlined
                        dense
                        hide-details
                        attach="#graph"
                        v-model="listSelection"
                        :items="list_date_folders"
                        v-on:change="getDataFolder"
                    >
                    <template v-slot:selection="data">
                        <v-container class="py-0">
                        <v-row>
                            {{ data.item.text.date ? data.item.text.date.split(' ')[0] : null }}
                            <v-spacer></v-spacer>
                            <v-chip
                                v-if="data.item.text.camera"
                                x-small
                            >
                            {{ data.item.text.camera }}
                            </v-chip>
                        </v-row>
                        </v-container>
                    </template>
                    <template v-slot:item="data">
                        <v-container class="py-0">
                        <v-row>
                            <v-col cols='8' class="pa-0">
                                {{ data.item.text.date ? data.item.text.date.split(' ')[0] : null }}
                            </v-col>
                            <v-col cols='auto' class="pa-0">
                                <v-chip
                                    v-if="data.item.text.camera"
                                    x-small
                                >
                                    {{ data.item.text.camera }}
                                </v-chip>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        </v-container>
                    </template>
                    </v-select>
                </div>
                <div class="d-flex align-center">
                    <v-btn @click="goToMap" color="primary" class="mr-4" style="height:40px;">
                    <v-icon>mdi-map-outline</v-icon>
                    <span>マップ</span>
                    </v-btn>
                    <v-btn @click="goToReport" color="warning" style="height:40px;">
                    <v-icon>mdi-file-chart-outline</v-icon>
                    <span>レポート</span>
                    </v-btn>
                </div>
            </v-col>
            <apexchart
            v-if="checkDonut"
            type="donut"
            height="400"
            :options="chartDonut.options"
            :series="chartDonut.series"
            ></apexchart>
        </v-card>

        <v-card class="mt-4">
            <v-toolbar flat>
                <v-toolbar-title>
                    <b>異常数の推移</b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <apexchart
            v-if="checkBar"
            class="pl-100"
            height="400"
            :options="chartBar.options"
            :series="chartBar.series"
            ></apexchart>
        </v-card>
    </v-container>
</template>

<script>
import {store} from '../store';
import router from "@/router";
import VueApexCharts from 'vue-apexcharts'
export default {
    name: "Site",
    components: {
        apexchart: VueApexCharts,
    },

    data() {
        return {
            // アノテーション種類定義
            types: [
                { text: "ホットスポット", value: "cell" },
                { text: "マルチホットスポット", value: "multicell" },
                { text: "クラスタバイパス", value: "cluster" },
                { text: "モジュール異常", value: "module" },
                { text: "ストリング異常", value: "string" },
                { text: "ジャンクションボックス過熱", value: "junction" },
                { text: "ＰＩＤ現象の疑い", value: "pid" },
                { text: "影", value: "shadow" },
            ],
            // 合計異常グラフの apextcharts js
            chartDonut: {
                options: {
                    chart: {
                        type: 'donut',
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom',
                            }
                        }
                    }],
                    colors: ['rgba(255, 109, 0, 0.7)', 'rgba(244, 221, 26, 1)', 'rgba(213, 0, 0, 0.7)', 'rgba(150, 0, 61, 0.7)', 'rgba(64, 0, 124, 0.7)', 'rgba(76, 175, 80, 0.7)', 'rgba(27, 94, 32, 0.7)', 'rgba(45, 121, 179, 0.7)' ],
                    labels: ["ホットスポット", "マルチホットスポット", "クラスタバイパス", "モジュール異常", "ストリング異常", "ジャンクションボックス過熱", "ＰＩＤ現象の疑い", "影" ],
                    plotOptions: {
                        pie: {
                            donut: {
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    showAlways: true,
                                    label: '合計',
                                    fontSize: '22px',
                                    fontFamily: 'Helvetica, Arial, sans-serif',
                                    fontWeight: 600,
                                    color: '#373d3f',
                                    formatter: function (w) {
                                        return w.globals.seriesTotals.reduce((a, b) => {
                                        return a + b
                                        }, 0)

                                    }
                                }
                            }
                            }
                        }
                    },
                    legend: {
                        width: 450,
                        show: true,
                        formatter: function (val, opts) {
                            if (opts.w.globals.seriesPercent[opts.seriesIndex]){
                                if (opts.w.globals.seriesPercent[opts.seriesIndex][0]){
                                    if (opts.w.globals.seriesPercent[opts.seriesIndex][0] < 0.01 && opts.w.globals.seriesPercent[opts.seriesIndex][0] > 0){
                                        return "<v-card class='labels'><v-card-title style='width:230px; display: inline-flex;'>"+ val +"</v-card-title>"+
                                        "<v-card-title style='display: inline-flex;'> <div class='text-right' style='font-weight: bold; width:90px;'>"+ opts.w.globals.series[opts.seriesIndex] +"</div></v-card-title>"+
                                        "<v-card-title style='display: inline-flex;'><div class='text-right' style='width:80px;'>"+ opts.w.globals.seriesPercent[opts.seriesIndex][0].toFixed(1-Math.floor(Math.log(opts.w.globals.seriesPercent[opts.seriesIndex][0])/Math.log(10))) +"</div>%</v-card-title></v-card>"
                                    }
                                    return "<v-card class='labels'><v-card-title style='width:230px; display: inline-flex;'>"+ val +"</v-card-title>"+
                                    "<v-card-title style='display: inline-flex;'><div class='text-right' style='font-weight: bold; width:90px;'>"+ opts.w.globals.series[opts.seriesIndex] +"</div></v-card-title>"+
                                    "<v-card-title style='display: inline-flex;'><div class='text-right' style='width:80px;'>"+ (Math.round(opts.w.globals.seriesPercent[opts.seriesIndex][0] * 10) / 10).toFixed(1) +"%</div></v-card-title></v-card>"
                                }
                            }
                            return "<v-card class='labels'><v-card-title style='width:230px; display: inline-flex;'>"+ val +"</v-card-title>"+
                            "<v-card-title style='display: inline-flex;'><div class='text-right' style='font-weight: bold; width:90px;'>"+ opts.w.globals.series[opts.seriesIndex] +"</div></v-card-title>"+
                            "<v-card-title style='display: inline-flex;'><div class='text-right' style='width:80px;'>"+ 0 +"%<div></v-card-title></v-card>"
                        },
                        onItemClick: {
                            toggleDataSeries: false
                        },
                        onItemHover: {
                            highlightDataSeries: false
                        },
                    },
                    noData: {
                        text: '該当なし',
                        align: 'center',
                        verticalAlign: 'top',
                        offsetY: 10,
                        style: {
                            fontSize: '20px',
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return(Math.round(val * 10) / 10).toFixed(1) + "%";
                        },
                    },
                },
                series:[],
            },
            // 過去と比較の apextcharts js
            chartBar: {
                series: [],
                options: {
                    chart: {
                        
                        type: 'bar',
                        stacked: true,
                        toolbar: {
                            show: false,
                        },
                        zoom: {
                            enabled: false,
                        }
                    },
                    responsive: [{
                        breakpoint: 100,
                        options: {
                            legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                            }
                        }
                    }],
                    plotOptions: {
                        bar: {
                            size: '65%',
                            horizontal: false,
                            borderRadius: 0,
                            columnWidth: '10px',
                        },
                    },
                    noData: {
                        text: '該当なし',
                        align: 'center',
                        verticalAlign: 'top',
                        offsetY: 0,
                        offsetX: 0,
                        style: {
                            fontSize: '20px',
                        }
                    },
                    xaxis: {
                        type: 'category',
                        categories: [],
                    },
                    yaxis: {
                        show: true,
                    },
                    legend: {
                        show: true,
                        position: 'bottom',
                        offsetX: 0,
                        offsetY: 0, 
                        markers: {
                            width: 12,
                            height: 12,
                            strokeWidth: 0,
                            strokeColor: '#fff',
                            fillColors: ['rgba(255, 109, 0, 0.7)', 'rgba(244, 221, 26, 1)', 'rgba(213, 0, 0, 0.7)', 'rgba(150, 0, 61, 0.7)', 'rgba(64, 0, 124, 0.7)', 'rgba(76, 175, 80, 0.7)', 'rgba(27, 94, 32, 0.7)', 'rgba(45, 121, 179, 0.7)' ],
                            radius: 12,
                            offsetX: 0,
                            offsetY: 0
                        },                      
                    },
                    fill: {
                        colors: ['rgba(255, 109, 0, 0.7)', 'rgba(244, 221, 26, 1)', 'rgba(213, 0, 0, 0.7)', 'rgba(150, 0, 61, 0.7)', 'rgba(64, 0, 124, 0.7)', 'rgba(76, 175, 80, 0.7)', 'rgba(27, 94, 32, 0.7)', 'rgba(45, 121, 179, 0.7)' ],
                        opacity: 1
                    },
                },
            },
            num_DC: 0,
            num_AC:0,
            camera: null,
            id: this.$route.params.id,  //uuid of report in report table

            list_date_folders: [],
            all_reports: null,
            listSelection: null,

            breadcrumbs: [
                {
                    text: "ダッシュボード",
                    disabled: false,
                    exact: true,
                    to: "/dashboard"
                },
                {
                    text: "",
                    disabled: false,
                    exact: true,
                },
            ],

            checkDonut: false,
            checkBar: false,
        }
    },

    methods: {
        getData() {
            this.axios.get("/api/dashboard/site/"+ this.id) 
            .then((response) => {
                this.chartDonut.series= [];
                this.breadcrumbs[1].text = response.data.annotation.plantName;

                store.updateMapviewBreadcrumbs([
                  {
                    text: "ダッシュボード",
                    disabled: false,
                    exact: true,
                    to: "/dashboard"
                  },
                  {
                    text: response.data.annotation.plantName,
                    disabled: false,
                    exact: true,
                    to: "/site/" + this.id
                  },
                ])

                store.updateReportBreadcrumbs([
                  {
                    text: "ダッシュボード",
                    disabled: false,
                    exact: true,
                    to: "/dashboard"
                  },
                  {
                    text: response.data.annotation.plantName,
                    disabled: false,
                    exact: true,
                    to: "/site/" + this.id
                  },
                ])

                this.num_DC = Math.round(response.data.annotation.plantDC * 10) / 10;
                this.num_AC = Math.round(response.data.annotation.plantAC * 10) / 10;
                this.camera = response.data.camera;
                this.check = true;
                for (var i in response.data.list_errors) {
                    // this.chartDonut.options.labels.push(this.getTextAnnotation(i));
                    this.chartDonut.series.push(response.data.list_errors[i]);
                }

                if (this.chartDonut.series.every(item => item === 0)){
                    this.chartDonut.series = [];
                    this.chartDonut.options.legend["showForNullSeries"] = false;
                }
                else {
                    this.chartDonut.options.legend["showForNullSeries"] = true;
                }
                this.checkDonut = true;

                for (var category in response.data.categories) {
                    this.chartBar.options.xaxis.categories.push(response.data.categories[category]['date']);
                }
                response.data.categories.sort((a,b) => new Date(b.date) - new Date(a.date));
                response.data.categories.forEach(element => {
                    this.list_date_folders.push({
                        value: element.id,
                        text: element,
                    })
                });
               
                this.listSelection = response.data.annotation.id;

                for (var idx in response.data.series) {
                    this.chartBar.series.push(
                    {
                        name: this.getTextAnnotation(response.data.series[idx]['name']),
                        data: response.data.series[idx]['data']
                    }
                );
                }
                if (this.list_date_folders.length == 0 ) {
                    this.chartBar.series = [];
                    this.chartBar.options.xaxis.categories = [];
                    this.chartBar.options.yaxis["showForNullSeries"] = false;
                    this.chartBar.options.legend["showForNullSeries"] = false;
                }
                if (this.list_date_folders.length == 1 ) {
                    if (this.chartBar.series.every(item => item['data'][0] === 0)){
                        this.chartBar.series = [];
                        this.chartBar.options.xaxis.categories = [];
                        this.chartBar.options.yaxis["showForNullSeries"] = false;
                        this.chartBar.options.legend["showForNullSeries"] = false;
                    }
                    else {
                        this.chartBar.options.legend["showForNullSeries"] = true;
                    }

                }
                this.checkBar = true;
                this.all_reports = response.data.all_reports;
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            })
        },
        getTextAnnotation(type) {
            if(type == null) {
                return "";
            } else {
                const annotationTypes = this.types;
                return annotationTypes.find(x =>x.value == type).text;
            }
        },
        getDataFolder() {
            this.checkDonut = false;
            this.chartDonut.series = [];
            const report = this.all_reports.find(x => x.id == this.listSelection);
            router.push({name: "Site", params: {id: report.uuid}});
            this.axios.get("/api/dashboard/site/"+ report.uuid)
            .then((response) => {
                for (var i in response.data.list_errors) {
                    this.chartDonut.series.push(response.data.list_errors[i]);
                }
                if (this.chartDonut.series.every(item => item === 0)){
                    this.chartDonut.series = [];
                    this.chartDonut.options.legend["showForNullSeries"] = false;
                }
                else {
                    this.chartDonut.options.legend["showForNullSeries"] = true;
                }
                this.checkDonut = true;
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            })
        },
        goToMap(){
          const folder = this.list_date_folders.find(x => x.value === this.listSelection);
          if (folder.text.page_visible.length > 0){
            this.$router.push('/map/' + folder.text.folder_uuid);
          }
          else {
            store.showErrorDialog('マップがありません。');
          }
        },
        goToReport(){
          const folder = this.list_date_folders.find(x => x.value === this.listSelection);
          this.$router.push('/report/' + folder.text.folder_uuid);
        },
        numberWithCommas(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },
    created() {
        this.getData();
    },
}
</script>

<style scoped>
.DC-AC-icon {
    background-color: lightblue !important;
    float: left;
    color: blue !important;
    font-size: x-large;
}
>>>.filter {
    position: absolute;
    right: 0px !important;
    top: 0px !important; 
}
>>>.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 15px;
}

>>>.v-btn:before {
    background-color: #fff !important;
}
>>>.v-menu__content {
    top: initial !important;
    left: initial !important;
}
>>>.donut .apexcharts-legend-series {
    position: relative;
    font-size: 20px;
}
>>>.donut .apexcharts-legend-text {
    position: absolute;
    width: calc(100% - 12px);
}
>>>.labels {
    position: absolute;
    width: 100% !important;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
}
#graph {
    width: 200px;
}


</style>
